export default __webpack_public_path__ + "static/media/interview02.42b9a829.jpg";